module.exports = __webpack_public_path__ + "img/img_13@2x.d5647cf7.png";